<div class="layout-container" [class.is-mobile]="mobileQuery.matches">
  <app-toolbar (menuToggle)="snav.toggle()"></app-toolbar>

  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      #snav
      #drawer
      [opened]="!mobileQuery.matches"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56"
    >
      <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content class="sidenav-content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
